import { Component, inject, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { ValidityDateType } from 'app/back-office/shared/enum/season-reference.enum';
import { SeasonsReferenceService } from 'app/shared/services/seasons-reference.service';
import { CustomizationRequestService } from 'app/shared/services/customization-request.service';
import { ShopContextStore } from 'app/shared/state/shop-context.store';

@Component({
    selector: 'app-customization-requests-filter',
    templateUrl: './customization-requests-filter.component.html',
    styleUrls: ['./customization-requests-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomizationRequestsFilterComponent implements OnInit {

  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;
  loaderId = UtilityFunctions.newGuid();

  searchSettings: SearchSettings = {
    placeholder: 'Search customization request...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [new FilterItem({ text: 'STATUS.ALL', value: null })];

  private _shopContext = inject(ShopContextStore);

  constructor(
    private _customizationRequest: CustomizationRequestService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionState && this.accordionState && this.dataToView.length === 1) {
      this.setDataToView(0);
    }
  }

  ngOnInit(): void {
  }

  onSearch(search: string) {
    this.searchValue = search;
    if (search === ''){ 
      this.dataToView = [new FilterItem({ text: 'STATUS.ALL', value: null })];
    }
    this.setDataToView(0);
  }

  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount ? skipCount - 1 : skipCount;
      this.setDataToView(next);
    }
  }
  
  setDataToView(skipCount: number) {
    (this.searchValue == undefined) ? this.searchValue = "" : null;
    const storeId = this._shopContext.currentShop().id;
    this._customizationRequest.getCustomizationRequest(this.loaderId, skipCount, 20, null, null, storeId, this.searchValue, null, null, 4, null, null, null, null, null).subscribe(element => {
      this.dataToView = element.items.map(el => FilterMapper.CustomizationRequestFilter(el));
      this.totalCount = element.totalCount + 1;
      });
    }
}
